
export const IConArrowUp = () => {

    return (
        <svg width="27" height="10" viewBox="0 0 27 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.5 8L13.0972 2.43333C13.6655 2.16058 14.329 2.17166 14.8878 2.46321L25.5 8" stroke="#525257" stroke-width="3" stroke-linecap="round" />
        </svg>

    );
};
